import axios from "axios";
// const apiBaseUrl = process.env.REACT_APP_API_URL;

export const getDataAPI = async (url, token) => {
  const res = await axios.get(`https://back-slidesface.onrender.com/api/${url}`, {
    headers: {
      Authorization: token,
    },
  });
  return res;
};

export const postDataAPI = async (url, post, token) => {
  const res = await axios.post(`https://back-slidesface.onrender.com/api/${url}`, post, {
    headers: {
      Authorization: token,
    },
  });
  return res;
};

export const putDataAPI = async (url, post, token) => {
  const res = await axios.put(`https://back-slidesface.onrender.com/api/${url}`, post, {
    headers: {
      Authorization: token,
    },
  });
  return res;
};

export const patchDataAPI = async (url, post, token) => {
  const res = await axios.patch(`https://back-slidesface.onrender.com/api/${url}`, post, {
    headers: {
      Authorization: token,
    },
  });
  return res;
};

export const deleteDataAPI = async (url, token) => {
  const res = await axios.delete(`https://back-slidesface.onrender.com/api/${url}`, {
    headers: {
      Authorization: token,
    },
  });
  return res;
};
